import { render } from "./InstitutionPayment.vue?vue&type=template&id=650a74a8&lang=pug"
import script from "./InstitutionPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./InstitutionPayment.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__